import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class EncryptedKeyService {
  private readonly SECRET = 'SikapBadungSecretKey2026!@J4Y4';
  private readonly IV_STR = 'SikapBadungIV2026';

  private async getCryptoKey(): Promise<CryptoKey> {
    const encoder = new TextEncoder();
    const keyHash = await window.crypto.subtle.digest(
      'SHA-256',
      encoder.encode(this.SECRET),
    );
    return await window.crypto.subtle.importKey(
      'raw',
      keyHash,
      { name: 'AES-CBC' },
      false,
      ['encrypt', 'decrypt'],
    );
  }

  public async encrypt(data: string): Promise<string> {
    const key = await this.getCryptoKey();
    const iv = new TextEncoder().encode(this.IV_STR.substring(0, 16));

    const encrypted = await window.crypto.subtle.encrypt(
      { name: 'AES-CBC', iv: iv },
      key,
      new TextEncoder().encode(data),
    );

    return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
  }
}
